import { VideoAspectRatio } from 'common/types/entities/VideoInterface'
import {
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
} from 'common/utils/styleUtilsNew'
import { BorderEntityInterface } from 'src/shared/schemas/border.schema'
import { getPaddingForRatio } from 'src/shared/utils/video-aspect-ratio'
import styled, { css } from 'styled-components'

type VideoPlaceholderUiProps = BorderEntityInterface & {
  boxShadow?: string
  mobileBoxShadow?: string
  aspectRatio?: VideoAspectRatio
}

const VideoPlaceholder = styled.div<VideoPlaceholderUiProps>`
  position: relative;
  padding-bottom: ${p => getPaddingForRatio(p.aspectRatio)}% !important;
  padding-top: 25px !important;
  overflow: hidden;
  ${borderCss};
  ${boxShadowCss};
  ${p => p.theme.phone} {
    ${mobileBorderCss};
    ${mobileBoxShadowCss};
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileBorderCss};
      ${mobileBoxShadowCss};
    `}
`

export default VideoPlaceholder
